import { ForwardedRef, ReactNode, forwardRef } from "react";
import { useMediaQuery } from "@mui/material";

interface IPdfCanvasScrollAreaProps {
    isWideLayout: boolean,
    children: ReactNode,
}

const PdfCanvasScrollArea = forwardRef((
    props: IPdfCanvasScrollAreaProps,
    ref: ForwardedRef<HTMLDivElement>,
) => {
    // Dokunmatik birincil cihazlarda (tablet) solda parmakla kaydırmak için canvas'ın
    // kaplamadığı bir scroll şeridi bırak.
    const isCoarsePointer = useMediaQuery("(pointer: coarse)");
    const gutterWidth = 50;

    return <div
        ref={ref}
        style={{
            width: "100%",
            overflow: "auto",
            flex: 1,
            minHeight: 0,
            minWidth: 0,
            paddingLeft: isCoarsePointer ? `${gutterWidth}px` : undefined,
            alignSelf: props.isWideLayout ? "stretch" : "center",
            // Sol scroll şeridi: hafif tint + ortada dikey "tutamak" noktaları.
            // Arka plan elemanın kutusuna sabittir; içerik üstünden kayar, şerit yerinde kalır.
            backgroundImage: isCoarsePointer
                ? `radial-gradient(circle at ${gutterWidth / 2}px center, rgba(0,0,0,0.22) 1.6px, transparent 2px), `
                    + "linear-gradient(to right, rgba(0,0,0,0.05), rgba(0,0,0,0.05))"
                : undefined,
            backgroundRepeat: isCoarsePointer ? "repeat-y, no-repeat" : undefined,
            backgroundSize: isCoarsePointer ? `${gutterWidth}px 18px, ${gutterWidth}px 100%` : undefined,
            backgroundPosition: isCoarsePointer ? "left top, left top" : undefined,
        }}>
        {props.children}
    </div>;
});

PdfCanvasScrollArea.displayName = "PdfCanvasScrollArea";

export default PdfCanvasScrollArea;
